<template>
  <div>
    <div class="tabs">
      <vue-horizontal class="horizontal" :displacement="0.5" :button-between="false">

				<template v-slot:btn-prev>
				<svg class="btn-left" viewBox="0 0 24 24">
					<path d="m9.8 12 5 5a1 1 0 1 1-1.4 1.4l-5.7-5.7a1 1 0 0 1 0-1.4l5.7-5.7a1 1 0 0 1 1.4 1.4l-5 5z"/>
				</svg>
			</template>
			
			<template v-slot:btn-next>
				<svg class="btn-right" viewBox="0 0 24 24">
					<path d="m14.3 12.1-5-5a1 1 0 0 1 1.4-1.4l5.7 5.7a1 1 0 0 1 0 1.4l-5.7 5.7a1 1 0 0 1-1.4-1.4l5-5z"/>
				</svg>
			</template>

        <div v-for="tab in tabs" :key="tab.id">
          <div class="tab" :class="{selected: selected === tab.id}" @click="selected = tab.id">
            <a :href="tab.url">{{ tab.title }}</a>
          </div>
        </div>
      </vue-horizontal>
    </div>
  </div>
</template>

<script>

import VueHorizontal from "vue-horizontal";

export default {
	components: { VueHorizontal },
  props: {
		initialSelectedId: {
			type: Number,
			required: false
		},
    tabs: {
      type: Array,
      required: true,
    },
		home: {
      type: Boolean,
      required: false,
		},
		homeTitle: {
      type: String,
      required: false,
		},
		homeUrl: {
      type: String,
      required: false
		},
		trending: {
			type: Boolean,
			required: false,
		},
		trendingTitle: {
			type: String,
			required: false,
		},
		trendingUrl: {
			type: String,
			required: false
		}
  },
  data() {
    return {
      selected: null
    }
  },
	created() {

		// Add popular tab
		if (this.trending) {
		
			const newTab2 = {
				id: 1000,
				url: this.trendingUrl,
				title: this.trendingTitle
			};
			this.tabs.unshift(newTab2);
		}
		// Add home tab
    if (this.home) {
      const newTab1 = {
        id: 0,
        url: this.homeUrl,
        title: this.homeTitle
      };
      this.tabs.unshift(newTab1);
    }
	},
	mounted() {

		var component = this;

		component.$logger('Vue/components/category-navigation/mounted');

		component.selected = component.initialSelectedId;

		if(typeof component.initialSelectedId != "undefined") {
			setTimeout(function() {
				component.selected = component.initialSelectedId;
				console.log('joejoe');
			}, 200);
		}
	}
}
</script>

<style scoped>

.v-hl-container {
	padding: 0px !important;
}
.btn-left, .btn-right {
  padding: 8px;
  height: 100%;
	opacity: 0.5;
	border-radius: 5px;
}

.btn-left {
  background: linear-gradient(to left, #ffffff00 0, #fff 30%, #fff);
  padding-right: 16px;
}

.btn-right {
  background: linear-gradient(to right, #ffffff00 0, #fff 30%, #fff);
  padding-left: 16px;
}

.tabs {
	max-height: 40px !important;
}

.tab {
  padding: 10px 14px 10px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
}
.tab a {
	color: var(--text-color-primary);
}
.tab a:hover {
	color: var(--tint-color);
}

.tab.selected a {
	color: var(--tint-color);

}

</style>

